import { useEffect, useState } from "react";
import { useFrame } from "react-frame-component";
import { useLocation, useRouteMatch } from "react-router-dom";
import { getCIQSdkUrl, hasCreditIQ } from "src/store/selectors/creditIQ";
import { getCreditIqSourceOrgId } from "src/store/selectors/vehicles";
import useSelector from "src/utils/useSelector";
import useFetchCiqToken from "./useFetchCIQToken";

export default function useLoadCreditIQSDK() {
    const [isLoaded, setIsLoaded] = useState(false);
    const iframe = useFrame();
    const isMenuingDrawer = useRouteMatch("/my-garage/");
    const location = useLocation<{ vin?: string }>();
    const vin = useSelector((state) =>
        isMenuingDrawer && !!location.state?.vin
            ? location.state.vin
            : state.currentDeal?.vin ?? state.onlineShopper.toggledVin!
    );
    const isPrequalOpen = useSelector((state) => state.onlineShopper.creditIQPrequalOpen);
    const sourceOrgId = useSelector((state) => getCreditIqSourceOrgId(state, vin));
    const ciqSdkUrl = useSelector((state) => getCIQSdkUrl(state, vin));
    const loadCIQ = useSelector((state) => hasCreditIQ(state, vin));

    // wait for sdk to load (presuming sdk SHOULD load) and if prequal, then prefetch the authBundle
    useFetchCiqToken(isPrequalOpen && loadCIQ && isLoaded ? vin : undefined);

    useEffect(() => {
        // find CIQ element if exists and remove it
        const el = iframe.document.getElementById("ciq-sdk");
        if (el) el.parentNode.removeChild(el);

        // don't load CIQ unless configured with CIQ integration
        if (!loadCIQ) {
            return;
        }

        const script = iframe.document.createElement("script");
        script.id = "ciq-sdk";
        script.type = "text/javascript";
        script.async = true;
        script.onload = function () {
            iframe.window.creditiq.init({
                sourceOrgId,
                useCustomButtons: false,
            });
            setIsLoaded(true);
        };
        script.src = ciqSdkUrl;
        const entry = iframe.document.getElementsByTagName("script")[0];
        entry?.parentNode.insertBefore(script, entry);
    }, [loadCIQ, sourceOrgId, ciqSdkUrl]);
}
